const controls = ['run', 'editor-wrap', 'notebook-content', 'title-play', 'step', 'tab-actions', 'tab-loops', 'tab-conditions'];

export function errorContext(document, hash, window) {
  return {
    error_level: /^#(?:jungle|temple|aegean|winter)-\d+$/.test(hash) ? hash.slice(1) : null,
    document_ready_state: document.readyState,
    missing_controls: controls.filter(id => !document.getElementById(id)),
    ...(window ? { page_visible: document.visibilityState === 'visible', online: window.navigator.onLine,
      viewport_width: window.innerWidth, viewport_height: window.innerHeight, pixel_ratio: window.devicePixelRatio } : {}),
  };
}
